import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import AutomaticMessageForm from 'components/AutomaticMessageForm';

import './AutomaticMessageModal.styles.scss';

type AutomaticMessageModalProps = {
  className?: string;
  leadFirstName: string;
  leadLastName: string;
  onSendNda: (message?: string) => void;
} & ModalProps;

const AutomaticMessageModal: React.ForwardRefRenderFunction<
  ModalRef,
  AutomaticMessageModalProps
> = (props, ref) => {
  const { className, leadFirstName, leadLastName, onSendNda, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('automatic-message-modal', className);

  const { t } = useTranslation();

  return (
    <Modal ref={modalRef} className={classes} title={t('sendingNDA')} {...rest}>
      <AutomaticMessageForm
        leadFirstName={leadFirstName}
        leadLastName={leadLastName}
        onCancel={modal?.close}
        onSendNda={onSendNda}
      />
    </Modal>
  );
};

export default forwardRef(AutomaticMessageModal);
